import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { direction: () => import('./DirectionPage.vue') },
} satisfies FeatureRoutes
